export default {"src":"/_next/static/image/public/images/ic_heart.6ce77f1b95743d1d38e1fd9454c21878.svg","height":12,"width":14};